const EARTH_RADIUS_MILES = 3959;
export const haversineMiles = (lat1, lon1, lat2, lon2) => {
    const dLat = ((lat2 - lat1) * Math.PI) / 180;
    const dLon = ((lon2 - lon1) * Math.PI) / 180;
    const a = Math.sin(dLat / 2) ** 2
        + Math.cos((lat1 * Math.PI) / 180)
            * Math.cos((lat2 * Math.PI) / 180)
            * Math.sin(dLon / 2) ** 2;
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return Math.round(EARTH_RADIUS_MILES * c * 10) / 10;
};
export const nearestLocationDistanceMiles = (userLat, userLng, locations) => {
    if (!Array.isArray(locations) || locations.length === 0)
        return null;
    let min = null;
    for (const loc of locations) {
        if (!loc || typeof loc.lat !== 'number' || typeof loc.lon !== 'number')
            continue;
        if (typeof loc.activeInventoryItems !== 'number' || loc.activeInventoryItems <= 0)
            continue;
        const d = haversineMiles(userLat, userLng, loc.lat, loc.lon);
        if (min === null || d < min)
            min = d;
    }
    return min;
};
//# sourceMappingURL=haversine.js.map